import { DateInputLocalized } from '@components'

import { Flex, IconButton, Spacing } from '@billy/design-system'
import React from 'react'
import { useTranslation } from 'react-i18next'

import * as Styled from './styles'

type DatePeriodChooserProps = {
  fromDate: Date | null
  toDate: Date | null
  onChangeFromDate: (fromDate: Date | null) => void
  onChangeToDate: (toDate: Date | null) => void
}

export const DatePeriodChooser = ({ fromDate, toDate, onChangeFromDate, onChangeToDate }: DatePeriodChooserProps) => {
  const { t } = useTranslation()

  return (
    <Flex flexDirection="column" gap={Spacing.S8}>
      <Flex flexDirection="row" alignItems="center" gap={Spacing.S12}>
        <Styled.FormLabel htmlFor="vouchers-from-date">{t('date.from')}</Styled.FormLabel>
        <DateInputLocalized
          datePickerPlacement="bottom-end"
          onChange={(date) => onChangeFromDate(date || null)}
          value={fromDate || undefined}
          id="vouchers-from-date"
        />
        <Flex>
          <IconButton icon="trash" variant="text" size="lg" onClick={() => onChangeFromDate(null)} />
        </Flex>
      </Flex>
      <Flex flexDirection="row" alignItems="center" gap={Spacing.S12}>
        <Styled.FormLabel htmlFor="vouchers-to-date">{t('date.to')}</Styled.FormLabel>
        <DateInputLocalized
          datePickerPlacement="bottom-end"
          onChange={(date) => onChangeToDate(date || null)}
          value={toDate || undefined}
          id="vouchers-to-date"
        />
        <Flex>
          <IconButton icon="trash" variant="text" size="lg" onClick={() => onChangeToDate(null)} />
        </Flex>
      </Flex>
    </Flex>
  )
}
